module.exports = __webpack_public_path__ + "img/2-fr.a581334f.jpg";